import { createContext, ReactNode, useContext } from 'react'

import { useFetchFeatureFlags } from '@/hooks/use-feature-flags'

import { useMarket } from '../market-context/market-context'

export interface FeatureFlags {
  [key: string]: boolean | undefined
}

export const FeatureFlagsContext = createContext<FeatureFlags | undefined>(
  undefined
)

export interface FeatureFlagsProviderProps {
  children: ReactNode
}

export function FeatureFlagsProvider({ children }: FeatureFlagsProviderProps) {
  const { country_code } = useMarket()
  const { data, error } = useFetchFeatureFlags(country_code)

  const flags: FeatureFlags = data ?? {}

  if (error) {
    console.error('Failed to fetch feature flags:', error)
  }

  return (
    <FeatureFlagsContext.Provider value={flags}>
      {children}
    </FeatureFlagsContext.Provider>
  )
}

export const useFeatureFlags = (flagName: keyof FeatureFlags): boolean => {
  const context = useContext(FeatureFlagsContext)
  if (context === undefined) {
    throw new Error('useFeatureFlags was used outside of its Provider')
  }
  return context[flagName] ?? false
}
